export function stableCatalogOrderV1015(sorted, previous) {
  const remaining = new Map(sorted.map((item) => [item.model_name, item]));
  const ordered = [];
  for (const name of previous) {
    if (!remaining.has(name)) continue;
    ordered.push(remaining.get(name));
    remaining.delete(name);
  }
  return [...ordered, ...remaining.values()];
}

export function captureCatalogAnchorV1015(container) {
  if (!container) return null;
  let scroller = container.parentElement;
  while (scroller && scroller !== document.scrollingElement) {
    if (
      /(auto|scroll|overlay)/.test(
        window.getComputedStyle(scroller).overflowY
      ) &&
      scroller.scrollHeight > scroller.clientHeight &&
      scroller.clientHeight > 0
    )
      break;
    scroller = scroller.parentElement;
  }
  if (scroller === document.scrollingElement) scroller = null;
  const scrollY = scroller ? scroller.scrollTop : window.scrollY;
  if (scrollY <= 0) return null;
  const viewportTop = scroller ? scroller.getBoundingClientRect().top : 0;
  const cards = [...container.querySelectorAll('[data-model]')];
  const index = cards.findIndex(
    (card) => card.getBoundingClientRect().bottom > viewportTop + 80
  );
  if (index < 0) return null;
  // Retain a nearby survivor if the currently viewed model is removed.
  const candidates = [
    ...cards.slice(index),
    ...cards.slice(0, index).reverse(),
  ];
  return {
    scroller,
    candidates: candidates.map((card) => ({
      name: card.dataset.model,
      top: card.getBoundingClientRect().top,
    })),
  };
}

export function restoreCatalogAnchorV1015(container, anchor) {
  if (!container || !anchor) return;
  const scroller = anchor.scroller;
  if (scroller && !scroller.isConnected) return;
  const cards = new Map(
    [...container.querySelectorAll('[data-model]')].map((card) => [
      card.dataset.model,
      card,
    ])
  );
  for (const candidate of anchor.candidates) {
    const card = cards.get(candidate.name);
    if (!card) continue;
    const delta = card.getBoundingClientRect().top - candidate.top;
    const scrollY = scroller ? scroller.scrollTop : window.scrollY;
    const target = Math.max(0, scrollY + delta);
    if (Math.abs(target - scrollY) > 1) {
      (scroller || window).scrollTo({
        top: target,
        left: scroller ? scroller.scrollLeft : window.scrollX,
        behavior: 'instant',
      });
    }
    return;
  }
}
